import { School } from '../school';
/**
 * Represents an unavailable period of time specified by a range of dates.
 * It's mostly used to exclude holidays or vacation days from a SchoolCalendar.
 */
export class UnavailableDate {
    constructor(
        public id?: number,
        public label?: string,
        public begining?: any,
        public ending?: any,
        public school?: School,
        public selected?: boolean
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/unavailable-date/unavailable-date.model.ts